import { SlidersHorizontal, UtensilsCrossed } from 'lucide-react';

import RestaurantTable from '../../../shared/RestaurantTable';
import { RestaurantMenuItemDTO } from '../../../../../types/restaurant/RestaurantMenuTypes';

interface Props {
  menuItems: RestaurantMenuItemDTO[];
  onConfigure: (dish: RestaurantMenuItemDTO) => void;
}

const ConfigButton = ({ onClick }: { onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex items-center gap-2 rounded-xl border border-stroke px-3 py-2 text-sm font-medium transition hover:border-primary hover:bg-primary/5 hover:text-primary dark:border-strokedark"
  >
    <SlidersHorizontal className="h-4 w-4" />
    Modificadores
  </button>
);

const DishModifierAssignmentTable = ({ menuItems, onConfigure }: Props) => {
  if (menuItems.length === 0) {
    return (
      <div className="flex min-h-[240px] flex-col items-center justify-center rounded-2xl border border-dashed border-stroke bg-gray-2/30 p-6 text-center dark:border-strokedark dark:bg-meta-4/20">
        <UtensilsCrossed className="h-9 w-9 text-primary/60" />
        <p className="mt-3 text-sm text-bodydark2">
          No hay platos que coincidan con el filtro.
        </p>
      </div>
    );
  }

  const columns = [
    {
      key: 'code',
      header: 'Código',
      className: 'w-28 font-mono text-xs text-bodydark2',
      cell: (row: RestaurantMenuItemDTO) => row.code,
    },
    {
      key: 'name',
      header: 'Plato',
      cell: (row: RestaurantMenuItemDTO) => (
        <div>
          <p className="font-medium text-black dark:text-white">
            {row.displayName || row.productName}
          </p>
          {!row.active && (
            <span className="text-[11px] font-semibold text-bodydark2">
              Inactivo
            </span>
          )}
        </div>
      ),
    },
    {
      key: 'category',
      header: 'Categoría',
      className: 'text-sm text-bodydark2',
      cell: (row: RestaurantMenuItemDTO) => row.categoryName,
    },
    {
      key: 'actions',
      header: '',
      className: 'text-right',
      cell: (row: RestaurantMenuItemDTO) => (
        <div className="flex justify-end">
          <ConfigButton onClick={() => onConfigure(row)} />
        </div>
      ),
    },
  ];

  return (
    <div className="p-5 sm:p-7">
      <RestaurantTable
        columns={columns}
        rows={menuItems}
        rowKey={(row) => row.id}
        rowClassName={(row) => (row.active ? '' : 'opacity-60')}
        minWidth="min-w-[720px]"
      />

      {/* Móvil */}
      <div className="space-y-3 md:hidden">
        {menuItems.map((dish) => (
          <div
            key={dish.id}
            className="rounded-xl border border-stroke p-4 dark:border-strokedark"
          >
            <p className="font-medium text-black dark:text-white">
              {dish.displayName || dish.productName}
            </p>
            <p className="mt-0.5 text-xs text-bodydark2">
              {dish.code} · {dish.categoryName}
            </p>
            <div className="mt-3">
              <ConfigButton onClick={() => onConfigure(dish)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DishModifierAssignmentTable;
